import { injectIntl } from "react-intl";
import { useState, useRef, useEffect } from "react";
import apiService from "src/services/api.service";
import { OperationType } from "src/helpers/Enums";

const NewCreative = (props) => {
  const textareaRef = useRef(null);
  const [creative, setCreative] = useState(
    props.operationType === OperationType.UPDATE
      ? props.creative
      : {
          name: "",
          offer_id: props.offerId,
          note: "",
          type: "Email",
        }
  );

  useEffect(() => {
    if (textareaRef.current && creative?.type === "SMS") {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [creative?.note, creative?.type]);

  const createUpdateCreative = () => {
    switch (props.operationType) {
      case OperationType.CREATE:
        apiService.createCreative(creative).then(() => props.closeModal());
        break;
      case OperationType.UPDATE:
        apiService.updateCreative(creative).then(() => props.closeModal());
        break;
    }
  };

  const handleInput = (param, value) => {
    setCreative({ ...creative, [param]: value });
  };

  return (
    <div className="NewStrategyModalOverlay z-[99]">
      <div className="NewStrategyModal">
        <div className={"w-full flex justify-between"}>
          <div className={"NewCreative"}>
            <img
              alt={"Logo"}
              src={"/media/icons/plusIconGray.svg"}
              className={"w-[18px] h-[18px]"}
            />
            {props.operationType === OperationType.CREATE ? "New" : "Edit"}
            Creative
          </div>
          <button className={"CloseIconButton"} onClick={props.closeModal}>
            <img
              alt={"Logo"}
              src={"/media/icons/closeIcon.svg"}
              className={"w-5 h-5"}
            />
          </button>
        </div>
        <div className="w-full flex flex-col gap-4 items-start self-stretch">
          <div className="h-[1px] self-stretch bg-[#E5E7F0]"></div>
          <div className={"NewListTypeButtons"}>
            <button
              onClick={() => handleInput("type", "Email")}
              className={
                creative?.type === "Email"
                  ? "NewListChosenButton"
                  : "NewListButton"
              }
            >
              Email Creative
              {creative?.type === "Email" && (
                <span className={"ChosenMarkerListType"}></span>
              )}
            </button>
            <img
              alt={"Logo"}
              src={"/media/icons/separate.png"}
              className={"h-[22px] w-[1px]"}
            />
            <button
              onClick={() => handleInput("type", "SMS")}
              className={
                creative?.type === "SMS"
                  ? "NewListChosenButton"
                  : "NewListButton"
              }
            >
              SMS Creative
              {creative?.type === "SMS" && (
                <span className={"ChosenMarkerListType"}></span>
              )}
            </button>
          </div>
          <div className={"NewStrategyInputSection"}>
            <div className={"NewStrategyInputTitle"}>
              {creative?.type === "Email" ? "Email" : "SMS"} Creative Name
            </div>
            <input
              className={"NewStrategyInput"}
              type="text"
              placeholder="Enter"
              onChange={(e) => handleInput("name", e.target.value)}
              value={creative?.name}
            />
          </div>
          <div
            className={
              creative?.type === "SMS"
                ? "NewStrategyInputSection hasTextarea"
                : "NewStrategyInputSection"
            }
          >
            <div className={"NewStrategyInputTitle"}>
              {creative?.type === "Email" ? "Creative Note" : "Message"}
              {creative?.type === "Email" && (
                <span className={"Optional"}>(Optional)</span>
              )}
            </div>
            {creative?.type === "SMS" ? (
              <textarea
                ref={textareaRef}
                className={"NewStrategyTextarea"}
                placeholder="Enter"
                onChange={(e) => handleInput("note", e.target.value)}
                value={creative?.note}
                rows={4}
              />
            ) : (
              <input
                className={"NewStrategyInput"}
                type="text"
                placeholder="Enter"
                onChange={(e) => handleInput("note", e.target.value)}
                value={creative?.note}
              />
            )}
          </div>
          <div className="h-[1px] self-stretch bg-[#E5E7F0]"></div>
          <div className="modal-actions">
            <button
              type="button"
              onClick={props.closeModal}
              className="CloseButton"
            >
              Close
            </button>
            <button
              type="submit"
              className="CreateButton"
              onClick={createUpdateCreative}
            >
              {props.operationType === OperationType.CREATE ? "Create" : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(NewCreative);
